<script>
    import { sgettext } from '../../../i18n';

    export let imageSrc;
    export let mainText;
    export let subText;
    export let altText = '';
    export let invalid = false;
    export let invalidTooltip = sgettext('$$INVALID_RISK_CONTROL_COMBINATION$$');
</script>

<div class="image-text-cell">
  {#if invalid}
    <i
      class="fa fa-exclamation-circle text-danger mr-2 mt-1"
      title={invalidTooltip}
    />
  {/if}
  {#if imageSrc}
    <img
      src={imageSrc}
      alt={altText}
      on:error={(e) => (e.target.style.display = 'none')}
    />
  {/if}
  <div class="label-container">
    <div class="text">{mainText}</div>
    <div class="subtext" title={subText}>{subText}</div>
  </div>
</div>

<style>
  .image-text-cell {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .image-text-cell img {
    width: 50px;
    height: 50px;
  }

  .label-container .text {
    font-weight: bold;
    font-size: medium;
  }
  .label-container {
    max-width: 100%;
    overflow: hidden;
  }
  .label-container .subtext {
    font-weight: normal;
    font-size: small;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .image-text-cell img {
    width: 50px;
    height: 50px;
  }
</style>
